import { render, staticRenderFns } from "./resumo-alteracoes.vue?vue&type=template&id=50e8d918&scoped=true"
import script from "./resumo-alteracoes.vue?vue&type=script&lang=js"
export * from "./resumo-alteracoes.vue?vue&type=script&lang=js"
import style0 from "./resumo-alteracoes.vue?vue&type=style&index=0&id=50e8d918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8d918",
  null
  
)

export default component.exports